import { HeadCell } from "../../../components/common/table/CustomTable";

export const headers: HeadCell[] = [
  {
    id: "number",
    label: "#",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "naviero",
    label: "naviero",
    disablePadding: false,
    numeric: false,
    width: "200px",
  },
  {
    id: "origen",
    label: "origen",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "destino",
    label: "destino",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "comm",
    label: "Commodity",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "contenedor",
    label: "Contenedor",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "contract",
    label: "contract number",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "notes",
    label: "Notes",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "f_creacion",
    label: "fecha de creación",
    disablePadding: false,
    numeric: false,
  },
  {
    id: "options",
    label: "opciones",
    disablePadding: false,
    numeric: false,
  },
];
